export default "__VITE_ASSET__Dmvfr$W$__"